export let EModalWebViewRoutes=function(EModalWebViewRoutes){EModalWebViewRoutes["WebView"]="WebView";return EModalWebViewRoutes;}({});